import { fromJS } from 'immutable';

import {
  LOAD_MEMBERS_SUCCESS,
  REMOVE_MEMBER,
  REMOVE_PENDING_MEMBER,
  REMOVE_PENDING_MEMBER_SUCCESS,
  REMOVE_MEMBER_SUCCESS,
  REMOVE_MEMBER_ERROR,
  SHOW_REMOVE_MODAL,
  HIDE_REMOVE_MODAL,
} from './constants';

const initialState = fromJS({
  members: {},
  pendingInvitations: {},
  removeMemberLoading: false,
  removeMemberError: null,
  removeMemberId: null,
});

function updatePendingInvitations(pendingInvitations, invitationId, organisationId) {
  const newPendingInvitations = pendingInvitations.updateIn([organisationId], pendingInvites =>
    pendingInvites.filter(pendingInvite => pendingInvite.get('id') !== invitationId),
  );
  if (!newPendingInvitations.get(organisationId).size > 0) {
    return newPendingInvitations.delete(organisationId);
  }
  return newPendingInvitations;
}

function campaignMembersReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_MEMBERS_SUCCESS:
    return state
      .set('members', action.members)
      .set('pendingInvitations', action.pendingInvitations);
  case REMOVE_MEMBER:
    return state
      .set('removeMemberId', action.permissionId)
      .set('removeMemberLoading', true)
      .set('removeMemberError', null);
  case REMOVE_PENDING_MEMBER:
    return state
      .set('removeMemberId', action.invitationId)
      .set('removeMemberLoading', true)
      .set('removeMemberError', null);
  case REMOVE_MEMBER_SUCCESS:
    return state
      .set('removeMemberId', null)
      .set('members', state.get('members').delete(action.permissionId))
      .set('removeMemberLoading', false)
      .set('removeMemberError', null);
  case REMOVE_PENDING_MEMBER_SUCCESS:
    return state
      .set('removeMemberId', null)
      .set('pendingInvitations', updatePendingInvitations(state.get('pendingInvitations'), action.invitationId, action.organisationId))
      .set('removeMemberLoading', false)
      .set('removeMemberError', null);
  case REMOVE_MEMBER_ERROR:
    return state
      .set('removeMemberId', null)
      .set('removeMemberLoading', false)
      .set('removeMemberError', action.error);
  case SHOW_REMOVE_MODAL:
    return state.set('removeMemberId', action.id);
  case HIDE_REMOVE_MODAL:
    return state.set('removeMemberId', null);
  default:
    return state;
  }
}

export default campaignMembersReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-members-manage/reducer.js
 **/